import { api } from "../api";
import { store } from "../store";
import { lang } from "../lang";
import * as HelperSrc from "../HelperSrc";

async function createDatabase(database: string): Promise<boolean> {
    if (api.clientApi) {
        await api.clientApi.clientCreate(database).then((response) => {
            if (response instanceof Error || (response.message && response.message.error)) {
                if (response instanceof Error) {
                    HelperSrc.writeLog("error", response);
                } else {
                    store.doNotice(lang[response.message.error]);
                }

                return false;
            } else {
                store.doNotice(lang.createDbSuccess, true);

                return true;
            }
        });
    }

    return false;
}

export { createDatabase };
